export const debugLog = (...args: any[]) => {
  if (localStorage.getItem('HYEXT_WEB_MID_DEBUG_LOG') === '1') {
    console.log.apply(console, args)
  }
}
